import { Flex, IconButton, TableRowsIcon, ViewModuleIcon } from '@tradener/lumen';

import useColorMode from '~/hooks/useColorMode';

export type CounterpartyChartLayoutProps = 'horizontal' | 'vertical';

export interface CounterpartyChartLayoutSelectorProps {
  layout: CounterpartyChartLayoutProps;
  onChange: (layout: CounterpartyChartLayoutProps) => void;
}

const LAYOUT_OPTIONS: Array<{
  icon: typeof ViewModuleIcon;
  label: string;
  value: CounterpartyChartLayoutProps;
}> = [
  { icon: ViewModuleIcon, label: 'Organizar gráficos lado a lado', value: 'horizontal' },
  { icon: TableRowsIcon, label: 'Organizar gráficos em coluna', value: 'vertical' },
];

function CounterpartyChartLayoutSelector({ layout, onChange }: CounterpartyChartLayoutSelectorProps) {
  const { colorTernary } = useColorMode();

  return (
    <Flex align="center" justify="flex-end" width="full" paddingInline="5" paddingTop="1" paddingBottom="3">
      <Flex align="center" justify="flex-end" gap="2" data-testid="counterparty-chart-layout-selector">
        {LAYOUT_OPTIONS.map(({ icon, label, value }) => {
          const isActive = value === layout;
          const IconComponent = icon;

          return (
            <IconButton
              key={value}
              aria-label={label}
              aria-pressed={isActive}
              icon={<IconComponent boxSize="4" />}
              variant="ghost"
              boxSize="2.25rem"
              minW="2.25rem"
              minH="2.25rem"
              borderRadius="lg"
              colorScheme={isActive ? 'brand' : 'gray'}
              bg={isActive ? 'brand.500' : colorTernary('gray.100', 'gray.200')}
              color={isActive ? 'white' : colorTernary('gray.500', 'gray.700')}
              _hover={{
                bg: isActive ? 'brand.600' : colorTernary('gray.200', 'gray.300'),
                color: isActive ? 'white' : colorTernary('gray.700', 'gray.800'),
              }}
              _active={{ bg: isActive ? 'brand.700' : colorTernary('gray.200', 'gray.300') }}
              onClick={() => onChange(value)}
            />
          );
        })}
      </Flex>
    </Flex>
  );
}

export default CounterpartyChartLayoutSelector;
